export const PRIVILEGE = {
    BRAND: {
        BRAND: {
            CREATE: 'brand.brand.create',
            EDIT: 'brand.brand.edit'
        }
    },
    HUB: {
        USER: {
            INDEX: 'hub.user.index',
            CREATE: 'hub.user.create',
            EDIT: 'hub.user.edit',
            DESTROY: 'hub.user.destroy'
        }
    },
    CAMPAIGN: {
        CAMPAIGN: {
            SHOW: 'campaign.campaign.show',
            EDIT: 'campaign.campaign.edit',
            CREATE: 'campaign.campaign.create',
            PROCESS: 'campaign.campaign.process'
        },
        APPLICATION: {
            PROCESS: 'campaign.application.process',
            INDEX: 'campaign.application.index'
        },
        INVITE: {
            INDEX: 'campaign.invite.index'
        },
        COLLABORATION: {
            PROCESS: 'campaign.collaboration.process',
            INDEX: 'campaign.collaboration.index',
            DESTROY: 'campaign.collaboration.destroy'
        },
        PERFORMANCE: {
            INDEX: 'campaign.performance.index'
        },
        PAYMENT : {
            INDEX: 'campaign.payment.index'
        },
        COLLABORATION_MILESTONE: {
            FORCE: 'campaign.collaboration_milestone.force',
            REFRESH: 'campaign.collaboration_milestone.refresh',
            RESET: 'campaign.collaboration_milestone.reset'
        },
        COLLABORATION_STEP: {
            UNDO: 'campaign.collaboration_step.undo',
            FORCE: 'campaign.collaboration_step.force'
        },
    },
    INFLUENCER: {
        INFLUENCER: {
            AI_OPS: 'influencer.influencer.ai_ops'
        }
    }
}